import { useLayoutEffect, useRef } from 'react';

/**
 * Llama a `reset` cada vez que un diálogo pasa de cerrado a abierto, para que un
 * formulario de crear/editar no muestre lo último editado en una apertura anterior.
 * Pasa el `open` real del diálogo (no uno combinado con sub-diálogos como el mapa),
 * así abrir un selector encima del formulario no borra lo capturado.
 */
export function useResetOnOpen(open: boolean, reset: () => void): void {
  const prev = useRef(open);
  const latest = useRef(reset);
  latest.current = reset;
  useLayoutEffect(() => {
    if (open && !prev.current) latest.current();
    prev.current = open;
  }, [open]);
}
